/**
 * Organization profile API – all endpoints used by organization profile pages.
 * Base path: /org/profile (organization profile routes mounted in backend organization routes).
 */
import { GET, POST, UPLOAD_FILE } from "../../apiController";

const ORG_PROFILE = '/admin/profile';

export const getProfile = () => {
  return GET(`${ORG_PROFILE}/get_profile`);
};

export const editProfile = (data) => {
  return POST(`${ORG_PROFILE}/edit_profile`, data);
};

export const updateProfilePic = (data) => {
  return UPLOAD_FILE(`${ORG_PROFILE}/update_profile_pic`, data);
};

export const changePassword = (data) => {
  return POST(`${ORG_PROFILE}/change_password`, data);
};

export const getProfileComments = (user_id) => {
  return GET(`${ORG_PROFILE}/get_profile_comments/${user_id}`);
};